var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSitesV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4531 7.56211C11.668 6.98009 11.7962 6.38542 11.7962 5.79557C11.7962 4.51853 11.2889 3.29379 10.3859 2.39078C9.48291 1.48777 8.25816 0.980469 6.98112 0.980469C5.70407 0.980469 4.47933 1.48777 3.57633 2.39078C2.67332 3.29379 2.16602 4.51853 2.16602 5.79557C2.16602 8.8008 5.49987 11.9306 6.61939 12.8972C6.72368 12.9757 6.85063 13.0181 6.98112 13.0181C7.11161 13.0181 7.23856 12.9757 7.34285 12.8972C7.50843 12.754 7.67156 12.6079 7.83219 12.4591",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98145 7.60352C7.97869 7.60352 8.78711 6.79509 8.78711 5.79785C8.78711 4.80061 7.97869 3.99219 6.98145 3.99219C5.9842 3.99219 5.17578 4.80061 5.17578 5.79785C5.17578 6.79509 5.9842 7.60352 6.98145 7.60352Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38867 10.612L10.5924 11.8158L13 9.4082",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitesV2);
export default __webpack_public_path__ + "static/media/sitesV2.14e356a0ed60b05c4eeac7fae5d137cc.svg";
export { ForwardRef as ReactComponent };